/**
 * 聊天入口：悬在底部框体右上角的一颗气泡（倒计时环在左侧）。
 *
 * 36px 圆，只探出框体 10px —— 2/6/8 人桌实测，自己的座位牌、买分入口、结算卡的下沿
 * 向上多提一些，扩大的点击区也不压框体里的预选胶囊，让窄屏把整行宽度留给动作文字。
 */
import type { ReactNode } from 'react'

import { IconChat, IconClose } from '../icons/index.js'

export interface TalkEntryProps {
  readonly open: boolean
  readonly composing: boolean
  readonly unread: number
  readonly hasDraft: boolean
  readonly onToggle: () => void
}

export function TalkEntry({ open, composing, unread, hasDraft, onToggle }: TalkEntryProps): ReactNode {
  const label = open ? '收起聊天' : unread > 0 ? `聊天，${String(unread)} 条未读` : '聊天'
  return (
    <button
      type="button"
      className="talk-fab"
      data-open={open ? 'on' : 'off'}
      data-composing={composing ? 'on' : 'off'}
      aria-label={label}
      aria-expanded={open}
      aria-controls="talk-drawer"
      // 打字时点它 = 收起：按下就处理，别让输入框先失焦、键盘先收一半再弹回来
      onPointerDown={(e) => {
        if (composing) e.preventDefault()
      }}
      onClick={onToggle}
    >
      {open ? <IconClose size={16} /> : <IconChat size={18} />}
      {!open && unread > 0 && <span className="talk-fab__badge num">{unread > 9 ? '9+' : unread}</span>}
      {!open && unread === 0 && hasDraft && <span className="talk-fab__dot" aria-hidden="true" />}
    </button>
  )
}
